import React from 'react';
import cx from 'classnames';

import { ErrorText } from '../error-text';

import './text-area.styles.scss';

export type TextAreaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
	errorMessage?: string;
};

export const TextArea: React.FC<TextAreaProps> = ({ className, errorMessage, ...otherProps }) => {
	return (
		<>
			<textarea 
				className={cx('TextArea form-control', className)}
				{...otherProps}
			/>
			{errorMessage && (
				<ErrorText withTopGap className="TextArea__error-message">
					{errorMessage}
				</ErrorText>
			)}
		</>
	);
};